import React, { useState, useEffect } from 'react';
import './InputForm.css';
import axios from 'axios';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer } from 'react-toastify';

function InputForm({ onSubmit }) {
  const [loanAmounts, setLoanAmounts] = useState(['']);
  const [totalLoanAmount, setTotalLoanAmount] = useState(0);
  const [coverage, setCoverage] = useState('');
  const [tenure, setTenure] = useState('');
  const [tenureGpa, setTenureGpa] = useState("");
  const [pricingData, setPricingData] = useState({});
  const [pricingDataGpa, setPricingDataGpa] = useState({});
  const [gst, setGST] = useState('');
  const [exclusiveGST, setExclusiveGST] = useState('');
  const [gtlAmount, setGtlAmount] = useState(0);
  const [gpaAmount, setGpaAmount] = useState(0);
  const [premiumExcGST, setPremiumExcGST] = useState("");
  const [closestGtlAmount, setClosestGtlAmount] = useState(0)
  const [closestGpaAmount, setClosestGpaAmount] = useState(0)
  const [gstGtl, setGstGtl] = useState(0);
  const [gstGpa, setGstGpa] = useState(0)


  useEffect(() => {
    toast.error(
      "🚀 महत्वपूर्ण अपडेट! Flashaid अब Flashaid Plus बन गया है, जिसमें बेहतर सुविधाएँ और अधिक सुरक्षा मिलेगी।\n" +
      "बीमा की कीमत बढ़ गई है।\n\n" + 
      "सभी बीमा हमारी साझेदार IRDAI पंजीकृत बीमा कंपनियों के माध्यम से प्रदान किए जाते हैं।"+
      "\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\n\n" +
      "\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\n\n" +  // Cre  // Creates spacing// ates spacing
      "Important Update!\n" + 
      "Flashaid is now Flashaid Plus with better features and more protection.\n" + 
      "Because of this, the insurance price has increased."+
      "All insurance is provided through partnered IRDAI registered Insurance providers.",
      { autoClose: 10000, position: 'top-center', closeOnClick: true }
    );
    const fetchPricingData = async () => {
      try {
        const response = await axios.get('https://flashaid-v3-prod-backend.flashaid.in/auth/v1/customer-insurance/tirumala/pricing-gtl');
        const transformedData = transformPricingData(response.data);
        setPricingData(transformedData);
        if (Object.keys(transformedData).length > 0) {
          setTenure(Object.keys(transformedData)[0]);
        }
      } catch (error) {
        console.error('Error fetching pricing data:', error);
      }
    };

    fetchPricingData();
  }, []);


  useEffect(() => {
    const fetchPricingDataGpa = async () => {
      try {
        const response = await axios.get(
          "https://flashaid-v3-prod-backend.flashaid.in/auth/v1/customer-insurance/tirumala/pricing-gpa"
        );
   
        const transformedData = transformPricingDataGpa(response.data);
        setPricingDataGpa(transformedData);
        if (Object.keys(transformedData).length > 0) {
          setTenureGpa(Object.keys(transformedData)[0]);
        }
      } catch (error) {
        console.error("Error fetching pricing data:", error);
      }
    };

    fetchPricingDataGpa();
  }, []);

  useEffect(() => {

  },[])

  const transformPricingDataGpa = (data) => {
    const result = {};
    data.forEach((item) => {
      const years = item["insuranceCoverageYears"];
      delete item["insuranceCoverageYears"];
      result[years] = item;
    });
    return result;
  };

  const transformPricingData = (data) => {
    const result = {};
    data.forEach(item => {
      const years = item['insuranceCoverageYears'];
      delete item['insuranceCoverageYears'];
      result[years] = item;
    });
    return result;
  };

  const handleLoanAmountChange = (index, value) => {
    const updatedLoanAmounts = [...loanAmounts];
    updatedLoanAmounts[index] = value;
    setLoanAmounts(updatedLoanAmounts);
    const totalAmount = updatedLoanAmounts.reduce((sum, amount) => sum + parseFloat(amount || 0), 0);
    setTotalLoanAmount(totalAmount);
   

    const maxGTL = 3000000;
    const gtl = Math.min(totalAmount, maxGTL);
    const gpa = totalAmount > maxGTL ? totalAmount - maxGTL : 0;
    

    setGtlAmount(gtl);
    setGpaAmount(gpa);
  };

  const addLoanAmountField = () => {
    setLoanAmounts([...loanAmounts, '']);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const premium = calculatePremium(totalLoanAmount, tenure);
    const tenure_value = tenure.replace(/_/g, " ");
     console.log(closestGtlAmount, closestGpaAmount, tenure_value, premium, gstGtl, gstGpa, premiumExcGST,"testv lpa")
    onSubmit({ closestGtlAmount, closestGpaAmount, tenure_value, premium, gstGtl, gstGpa, premiumExcGST });
  };

  // const calculatePremium = (loanAmount, tenure) => {
  //   if (!pricingData[tenure]) {
  //     return 'N/A';
  //   }
    
  //   const amounts = Object.keys(pricingData[tenure]).map(Number).sort((a, b) => a - b);
  //   let closestAmount = amounts.find(amount => amount >= loanAmount);
  //   if (!closestAmount) {
  //     closestAmount = amounts[amounts.length - 1];
  //   }
  //   setCoverage(closestAmount);
  //   const basePremium = pricingData[tenure][closestAmount];
    
  //   let amountWithoutCommas = basePremium.toString().replace(/,/g, "");
  //   let amountNumber = parseFloat(amountWithoutCommas);
  //   const premiumWithTax = (amountNumber + (amountNumber * 0.18)).toFixed(3);
  //   setGST((amountNumber * 0.18).toFixed(3));
  //   setExclusiveGST(amountNumber);
  //   return premiumWithTax;
  // };


  const calculatePremium = (loanAmount, tenure) => {
    const tenureNumber = parseInt(tenure.split("_")[0], 10);
    const adjustedTenure = tenureNumber;
    const tenureKey = `${adjustedTenure}_years`;
  
    if (!pricingData[tenureKey] || !pricingDataGpa[tenureKey]) {
      return "N/A";
    }
  
    let totalPremium = 0;
  
    // Function to find the closest premium for a given amount
    const getPremiumForAmount = (amount, pricingDataSource) => {
      const amounts = Object.keys(pricingDataSource[tenureKey])
        .map(Number)
        .sort((a, b) => a - b);
      
      let closestAmount = amounts.find((amt) => amt >= amount);
      if (!closestAmount) {
        closestAmount = amounts[amounts.length - 1];
      }
  
      let basePremium = pricingDataSource[tenureKey][closestAmount];
      let amountWithoutCommas = basePremium.toString().replace(/,/g, "");
      return parseFloat(amountWithoutCommas);
    };
  
    if (loanAmount > 3000000) {
      // Split into base and excess amounts
      const baseAmount = 3000000;
      const excessAmount = loanAmount - baseAmount;

     const amounts_gtl = Object.keys(pricingData[tenureKey]).map(Number).sort((a, b) => a - b);
    let closestAmount_gtl = amounts_gtl.find(amount => amount >= baseAmount);
    if (!closestAmount_gtl) {
      closestAmount_gtl = amounts_gtl[amounts_gtl.length - 1];
    }
    setClosestGtlAmount(closestAmount_gtl);

    const amounts_gpa = Object.keys(pricingDataGpa[tenureKey]).map(Number).sort((a, b) => a - b);
    let closestAmount_gpa = amounts_gpa.find(amount => amount >= excessAmount);
    if (!closestAmount_gpa) {
      closestAmount_gpa = amounts_gpa[amounts_gpa.length - 1];
    }
    setClosestGpaAmount(closestAmount_gpa);
  
      // Get premium for base amount from pricingData
      const basePremium = getPremiumForAmount(baseAmount, pricingData);
      // Get premium for excess amount from pricingDataGpa
      const excessPremium = getPremiumForAmount(excessAmount, pricingDataGpa);
       

      // set gst gtl
       let gtlAmountWithoutCommas = basePremium.toString().replace(/,/g, "");
       let gtlAmountNumber = parseFloat(gtlAmountWithoutCommas);
       setGstGtl((gtlAmountNumber * 0.18).toFixed(3));


        // set gst gtl
        let gpaAmountWithoutCommas = basePremium.toString().replace(/,/g, "");
        let gpaAmountNumber = parseFloat(gpaAmountWithoutCommas);
        setGstGpa((gpaAmountNumber * 0.18).toFixed(3));
  
      totalPremium = basePremium + excessPremium;
    } else {
      // Use pricingData if loanAmount is 3,000,000 or less
      const amounts_gtl = Object.keys(pricingData[tenureKey]).map(Number).sort((a, b) => a - b);
    let closestAmount_gtl = amounts_gtl.find(amount => amount >= loanAmount);
    if (!closestAmount_gtl) {
      closestAmount_gtl = amounts_gtl[amounts_gtl.length - 1];
    }
    setClosestGtlAmount(closestAmount_gtl);
      totalPremium = getPremiumForAmount(loanAmount, pricingData);
    }
  
    // Set premium excluding GST
    setPremiumExcGST(totalPremium);
  
    // Calculate final premium including GST
    const premiumWithTax = (totalPremium + totalPremium * 0.18).toFixed(3);
    return Math.ceil(premiumWithTax);
  };

  useEffect(() => {
    if (totalLoanAmount) {
      calculatePremium(totalLoanAmount, tenure);
    }
  }, [totalLoanAmount, tenure, pricingData]);

  return (
    <>
    <ToastContainer />
    <form onSubmit={handleSubmit} className="form-container">
      <h1 style={{ fontSize: "25px" }} className="form-title">Flashaid Loan Protection Plan</h1>
      {loanAmounts.map((loanAmount, index) => (
        <div className="input-group" key={index}>
          <label>Loan Amount {index + 1}:</label>
          <input
            type="number"
            value={loanAmount}
            onChange={(e) => handleLoanAmountChange(index, e.target.value)}
            placeholder="Please enter your loan amount here"
          />
        </div>
      ))}
      <button type="button" onClick={addLoanAmountField} className="add-loan-button">
        Add More Loan Amount
      </button>
      <div className="input-group">
        <label>Total Loan Amount:</label>
        <input
          type="number"
          value={totalLoanAmount}
          disabled
        />
      </div>
      <div className="input-group">
        <label>Coverage(GTL):</label>
        <input
          type="text"
          value={gtlAmount}
          disabled
        />
      </div>
      <div className="input-group">
        <label>Coverage(GPA):</label>
        <input
          type="text"
          value={gpaAmount}
          disabled
        />
      </div>
      <div className="input-group">
        <label>Tenure:</label>
        <select
          value={tenure}
          onChange={(e) => setTenure(e.target.value)}
        >
          {Object.keys(pricingData).map(key => (
            <option key={key} value={key}>{key.replace(/_/g, ' ')}</option>
          ))}
        </select>
      </div>
      <button type="submit" className="submit-button">Submit</button>
    </form>
  </>
  );
}

export default InputForm;